/* eslint no-param-reassign: "off" */
import * as types from '@/store/modules/whatsapp/mutation-types';

export default {
  [types.REQUEST_WHATSAPP_QRCODE_REQUEST]: state => {
    state.loadingWhatsappQRCodeRequest = true;
    state.whatsappQRCodeRequestFailed = false;
    state.whatsappQRCodeRequestSuccess = false;
  },
  [types.REQUEST_WHATSAPP_QRCODE_SUCCESS]: (state, payload) => {
    state.whatsappQRCode = payload.data;
    state.loadingWhatsappQRCodeRequest = false;
    state.whatsappQRCodeRequestFailed = false;
    state.whatsappQRCodeRequestSuccess = true;
  },
  [types.REQUEST_WHATSAPP_QRCODE_FAILURE]: state => {
    state.loadingWhatsappQRCodeRequest = false;
    state.whatsappQRCodeRequestFailed = false;
    state.whatsappQRCodeRequestSuccess = false;
  },
  [types.RESET_WHATSAPP_QRCODE]: state => {
    state.whatsappQRCode = null;
  },
  [types.RESET_WHATSAPP_CHANNEL_ID]: state => {
    state.whatsappChannelId = null;
  },
  [types.CREATE_WHATSAPP_CHANNEL_REQUEST]: state => {
    state.loadingWhatsappCreateChannel = true;
    state.whatsappChannelCreateSuccess = false;
    state.whatsappChannelCreateFailed = false;
  },
  [types.CREATE_WHATSAPP_CHANNEL_SUCCESS]: (state, payload) => {
    state.whatsappChannelId = payload.id;
    state.whatsappChannelCreateSuccess = true;
    state.whatsappChannelCreateFailed = false;
    state.loadingWhatsappCreateChannel = false;
  },
  [types.CREATE_WHATSAPP_CHANNEL_FAILURE]: state => {
    state.whatsappChannelCreateSuccess = false;
    state.whatsappChannelCreateFailed = true;
    state.loadingWhatsappCreateChannel = false;
  },
  [types.POLL_WHATSAPP_CHANNEL_START]: (state, interval) => {
    state.whatsappPollInterval = interval;
  },
  [types.POLL_WHATSAPP_CHANNEL_STOP]: state => {
    state.whatsappPollInterval = clearInterval(state.whatsappPollInterval);
  },
  [types.POLL_WHATSAPP_CHANNEL_SUCCESS]: state => {
    state.whatsappPollSuccess = true;
  },
  [types.POLL_WHATSAPP_CHANNEL_FAILURE]: state => {
    state.whatsappPollSuccess = false;
  },
  [types.POLL_WHATSAPP_CHANNEL_RESET]: state => {
    state.whatsappPollSuccess = null;
    state.whatsappPollInterval = null;
    state.whatsappPollChannelId = null;
  },
  [types.POLL_WHATSAPP_SET_CHANNEL]: (state, channelId) => {
    state.whatsappPollChannelId = channelId;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/whatsapp/mutations.js